import React, { Component } from "react";
import Constant from "../../Constant";
import { Link } from "react-router-dom";
import QuizPreview from "../Create/quiz/QuizPreview";
import CoursePreview from "../Create/HTML/CoursePreview";
import Video from "../video/Video";
import Audio from "../video/Audio";
import ZoomPlayer from "../video/ZoomPlayer";
import TextPdfPreview from "../video/TextPdfPreview";
//import HtmlUpload from '../trainer/unit/HtmlUpload';

export default class ViewTopic extends Component {
  constructor() {
    super();
    this.state = {
      videoURL: "",
      data: [],
      courseName: "",
      content: {
        elements: [],
      },
      questionsList: [{ game_type_id: "" }],
    };
  }

  componentDidMount() {
    this.getCourse();
    this.getTopic();
  }
  getCourse() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        this.setState({
          courseName: data.name,
          courseDisc: data.description,
          courseImage: data.image,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  }
  getTopic = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("topicId", this.props.match.params.topic_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data.contentType);
        if (result.data.contentType === "zoom") {
          if (localStorage.getItem("livelms_role") !== "learner") {
            this.setState({
              data: result.data,
              content: result.data.content,
            });
          } else {
            for (var i = 0; i < result.data.topic_users.length; i++) {
              console.log("learner");
              if (result.data.topic_users[i].user_id == localStorage.getItem('lms_uid')) {
                if (result.data.topic_users[i].joinUrl !== null && result.data.topic_users[i].joinUrl !== "") {
                  this.setState({
                    data: result.data,
                    content: result.data.topic_users[i].joinUrl,
                  });
                } else {
                  this.setState({
                    data: result.data,
                    content: result.data.content,
                  });
                }
              }
            }
          }
        } else {
          var content = JSON.parse(result.data.content);
          let temp;
          if (content.topicType == 4) {
            var questionsList = content.data;
            this.setState({ questionsList: questionsList });
          } else if (content.topicType == 6) {
            var htmlContent = content.data;
            this.setState({ htmlContent: htmlContent });
          } else if (content.topicType == "youtube") {
            const ID = content.videoURL;
            console.log("ID", ID);
            let index = ID.indexOf("=");
            temp = ID.slice(index + 1);
            this.setState({
              data: result.data,
              content: content,
              videoURL: temp,
            });
          } else if (content.topicType == "video") {
            const ID = content.video;
            this.setState({
              data: result.data,
              content: content,
              videoURL: ID,
            });
          }
          this.setState({
            data: result.data,
            content: content,
          });
        }
        console.log(this.state.data.content);
      })
      .catch((error) => console.log("error", error));
  };
  onCompleteTopic = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("topicId", this.props.match.params.topic_id);
    urlencoded.append("status", "Complete");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/topicStatus", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          window.location.href = `#/learner/course/${this.props.match.params.course_id}`
        }
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    console.log("OK", this.state.videoURL);
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-8 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    {localStorage.getItem("livelms_role") !== "learner" ? (
                      <span>
                        <Link to="/admin/dashboard">Home</Link> /{" "}
                        <Link to="/admin/courses">Courses</Link> /{" "}
                        <Link
                          to={`/admin/course/topics/${this.props.match.params.course_id}`}
                        >
                          {this.state.courseName}
                        </Link>{" "}
                        / {this.state.data.name}
                      </span>
                    ) : (
                        <span>
                          <Link to="/learner/course-list">Home</Link> /{" "}
                          <Link to="/learner/course-list">Courses</Link> /{" "}
                          <Link
                            to={`/learner/course/${this.props.match.params.course_id}`}
                          >
                            {this.state.courseName}
                          </Link>{" "}
                        / {this.state.data.name}
                        </span>
                      )}
                  </h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end align-items-center">
                  {localStorage.getItem("livelms_role") !== "learner" ? (
                    <Link
                      to={`/admin/edit-topic/${this.props.match.params.course_id}&${this.props.match.params.topic_id}`}
                      className="btn btn-dark float-right"
                    >
                      Edit Topic
                    </Link>
                  ) : (
                      this.state.data.topicStatus !== "complete" && this.state.data.topicStatus !== "Complete" && this.state.data.topicStatus !== "COMPLETE"
                        ?
                        <button className="btn btn-dark float-right" onClick={this.onCompleteTopic} >
                          Complete Topic
                      </button>
                        :
                        <span class="topic-ribbon1">
                          <span>Completed</span>
                        </span>)}
                </div>
              </div>
            </div>

            <div className="users-container p-4">
              {/* <div className="mw-100 mh-100 bg-danger text-center"> */}
              {this.state.content.topicType == 4 ? (
                <QuizPreview
                  questionsList={this.state.questionsList}
                  unitDetails={this.state.data}
                ></QuizPreview>
              ) : this.state.content.topicType == 6 ? (
                <CoursePreview
                  currentPage={this.state.htmlContent}
                  editMode={false}
                />
              ) : this.state.content.topicType === "youtube" ? (
                <Video
                  heading={this.state.data.name}
                  description={this.state.data.description}
                  ID={this.state.videoURL}
                  contentType={this.state.data.contentType}
                />
              ) : this.state.data.contentType === "zoom" ? (
                <ZoomPlayer url={this.state.content} />
              ) : this.state.data.contentType === "video" ? (
                <Video
                  heading={this.state.data.name}
                  description={this.state.data.description}
                  ID={this.state.videoURL}
                  contentType={this.state.data.contentType}
                />
              ) : this.state.data.contentType === "text" ? (
                <TextPdfPreview
                  heading={this.state.data.name}
                  description={this.state.data.description}
                  content={this.state.content.textFile}
                  contentType={this.state.data.contentType}
                />
              ) : this.state.data.contentType === "audio" ? (
                <Audio
                  heading={this.state.data.name}
                  description={this.state.data.description}
                  content={this.state.content.video}
                  contentType={this.state.data.contentType}
                />
              ) : this.state.data.contentType === "html" ? (
                {
                  /*
                <HtmlUpload
                  heading={this.state.data.name}
                  description={this.state.data.description}
                  ID={this.state.content.videoURL}
                  contentType={this.state.data.contentType}
                />
                */
                }
              ) : (
                                ""
                              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
